import HTage from './components/HTage.vue';
import altStats from './components/altStats.vue';
import iconUrl from './components/iconUrl.vue';

let setting = [
	// 标题
	{
		name: 'Meta Title',
		tips: '一个好的标题应该准确描述页面内容，并包含对应该页面内容重要的关键词',
		fun: data => {
			let { titleLength } = data;
			return 50 <= titleLength && titleLength <= 65;
		},
		suc: 'Title字符在建议的50-65个字符以内\n${title}，总计${titleLength}个字符',
		err: 'Title标签总计${titleLength}个字符，${titleTips}建议的${titleNum}个字符。Title长度过长可能导致重要信息在搜索结果页面上无法完全显示，而过短的标题可能无法充分描述页面内容或吸引用户注意。',
	},
	// 关键字
	{
		name: 'Meta Keywords',
		tips: 'Keywords对于全面理解网页优化有一定的价值，错误使用 Meta Keywords 实际上可能对网站的SEO造成负面影响',
		fun: data => {
			let { keywordsLength } = data;
			return keywordsLength <= 100;
		},
		suc: 'Keywords字符在建议的100个字符以内\n${keywords}，总计${keywordsLength}个字符',
		err: 'Keywords总计${keywordsLength}个字符，超过了建议的100个字符。在 Meta Keywords 标签中填入大量不相关的关键词以试图操纵搜索结果可能会影响到网站在搜索引擎的表现。',
	},
	// 描述
	{
		name: 'Meta Description',
		tips: '它们通常在搜索引擎结果页面（SERP）上显示为页面的描述，对提高转化率非常重要',
		fun: data => {
			let { descriptionLength } = data;
			return 150 <= descriptionLength && descriptionLength <= 160;
		},
		suc: 'Description字符在建议的150-160个字符以内\n${description}，总计${descriptionLength}个字符',
		err: 'Meta description总计${descriptionLength}个字符，${descriptionTips}建议的${descriptionNum}个字符，过长的描述可能会被搜索引擎截断，而过短则可能不足以提供足够的信息吸引用户点击。',
	},
	// 图标
	{
		name: '网站图标',
		tips: '站内图标可以传达出网站的专业性，增强品牌的可识别性，从而增加访问者对网站的信任感',
		err: '没有站内图标可能会使得用户在多个标签页之间切换时更难识别和定位特定网站，从而降低了用户的整体浏览体验。',
		fun: data => {
			let { iconUrl } = data;
			return !!iconUrl;
		},
		dataFun: data => {
			let { iconUrl } = data;
			return iconUrl;
		},
		components: iconUrl,
	},
	// 标签
	{
		name: 'H标签',
		tips: 'H标签可以明确页面中标题的层级关系，这对于搜索引擎和阅读器来理解页面内容非常重要',
		components: HTage,
		dataFun: data => {
			let { h1List: H1, h2List: H2, h3List: H3, h4List: H4, h5List: H5, h6List: H6 } = data;
			return {
				H1,
				H2,
				H3,
				H4,
				H5,
				H6,
			};
		},
	},
	// alt属性
	{
		name: 'Alt属性',
		tips: '优化良好的 alt 文本有助于改善网页的排名，并使图像更容易被搜索引擎索引',
		components: altStats,
		dataFun: data => {
			let { imgList } = data;
			return imgList;
		},
	},
	//  Sitemap地图
	{
		name: 'Sitemap地图',
		tips: '让搜索引擎更好地理解和索引网站内容，从而提高网站在搜索结果中的排名和曝光度',
		fun: data => {
			let { siteMapFlag } = data;
			return !!siteMapFlag;
		},
		suc: '您的网站有一个站点地图：${siteMapUrl}',
		err: '您的网站没有配置站点地图。站点地图可以加速新发布内容的索引速度。如果没有站点地图，搜索引擎可能需要更长时间来发现新内容。',
	},
	// 规范标签
	{
		name: '规范标签',
		tips: '规范网页内容的HTML标签属性，它的重要性在于解决了重复内容问题，提高了搜索引擎优化（SEO）和用户体验',
		fun: data => {
			let { canonical } = data;
			return !!canonical;
		},
		suc: '您的网页使用规范标签："${canonical}"',
		err: '没有规范标签，搜索引擎可能会将这些页面视为重复内容，这可能会降低网站的搜索引擎排名。',
	},
];

export default setting;
